import type { FollowUp, RealEstateCase } from "./types";
import { normalizePlannedActionCopy } from "./nextActionCopy.ts";

export const formatCurrency = (value: number) =>
  new Intl.NumberFormat("sk-SK", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0
  }).format(value);

export const formatDate = (date: string) => {
  const parsedDate = new Date(`${date}T00:00:00`);
  return new Intl.DateTimeFormat("sk-SK", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  }).format(parsedDate);
};

export const formatDateTime = (followUp: FollowUp) => `${formatDate(followUp.date)} o ${followUp.time}`;

export const nextStepLabel = (followUp?: FollowUp, fallback = "Chýba ďalší krok") =>
  followUp ? `${formatDateTime(followUp)} - ${normalizePlannedActionCopy(followUp.purpose)}` : fallback;

export const overdueDays = (followUp: FollowUp | undefined, today: string) => {
  if (!followUp?.date || followUp.date >= today) {
    return 0;
  }

  const planned = new Date(`${followUp.date}T00:00:00`);
  const current = new Date(`${today}T00:00:00`);
  return Math.max(0, Math.round((current.getTime() - planned.getTime()) / 86_400_000));
};

export const overdueLabel = (followUp: FollowUp | undefined, today: string) => {
  const days = overdueDays(followUp, today);

  if (days === 0) {
    return "";
  }

  if (days === 1) {
    return "Omeškané 1 deň";
  }

  if (days > 1 && days < 5) {
    return `Omeškané ${days} dni`;
  }

  return `Omeškané ${days} dní`;
};

export const propertyDisplayLabel = (caseItem: Pick<RealEstateCase, "propertyType" | "apartmentRooms">) => {
  if (caseItem.propertyType === "Byt" && caseItem.apartmentRooms) {
    return caseItem.apartmentRooms === "Garsónka" ? "Garsónka" : `${caseItem.apartmentRooms} byt`;
  }

  return caseItem.propertyType || "Iné";
};

export const caseContextLabel = (caseItem: Pick<RealEstateCase, "transactionType" | "propertyType" | "apartmentRooms">) =>
  `${caseItem.transactionType ?? "Iné"} · ${propertyDisplayLabel(caseItem)}`;
